const allergen_groups = {
  list: [
    {
      value: "eggs",
      de: "Eier",
      en: "Eggs",
      tr: "Yumurtalar",
      index: 4,
      allergens: ["AE"]
    },
    {
      value: "peanuts",
      de: "Erdnüsse",
      en: "Peanuts",
      tr: "Yer fıstığı",
      index: 11,
      allergens: ["AP"]
    },

    {
      value: "fish",
      de: "Fisch",
      en: "Fish",
      tr: "Balık",
      index: 5,
      allergens: [
        "ABH",
        "ADE",
        "ADU",
        "AF",
        "AWF",
        "BLF",
        "MKF",
        "ROF",
        "UN",
        "ADC"
      ]
    },
    {
      value: "gluten",
      de: "Glutenhaltiges Getreide",
      en: "Cereals containing gluten",
      tr: "Gluten içeren tahıllar",
      index: 2,
      allergens: ["AX", "BWD", "UW", "NR", "GB", "GO"]
    },
    {
      value: "crustaceans",
      de: "Krebstiere",
      en: "Crustaceans",
      tr: "Kabuklular",
      index: 3,
      allergens: ["AC", "ABL", "ABJ"]
    },
    {
      value: "lupin",
      de: "Lupine",
      en: "Lupin",
      tr: "Acı bakla",
      index: 6,
      allergens: ["NL"]
    },
    {
      value: "milk",
      de: "Milch",
      en: "Milk",
      tr: "Süt",
      index: 7,
      allergens: ["AM"]
    },
    {
      value: "nuts",
      de: "Schalenfrüchte (Nüsse)",
      en: "Nuts",
      tr: "Fındık",
      index: 10,
      allergens: [
        "AN",
        "SD",
        "SE",
        "SG",
        "SI",
        "SJ",
        "SK",
        "SL",
        "SN",
        "SO",
        "SA",
        "SW",
        "SH",
        "ST",
        "SC"
      ]
    },
    {
      value: "sulphites",
      de: "Schwefeldioxid/Sulfite",
      en: "Sulphur dioxide/Sulphites",
      tr: "Kükürt dioksit/Sülfit",
      index: 14,
      allergens: ["AU", "NP", "TTD"]
    },
    {
      value: "celery",
      de: "Sellerie",
      en: "Celery",
      tr: "Kereviz",
      index: 1,
      allergens: ["BC"]
    },
    {
      value: "mustard",
      de: "Senf",
      en: "Mustard",
      tr: "Hardal",
      index: 9,
      allergens: ["BM"]
    },
    {
      value: "sesame",
      de: "Sesam",
      en: "Sesame",
      tr: "Susam",
      index: 12,
      allergens: ["AS"]
    },
    {
      value: "soya",
      de: "Soja",
      en: "Soya",
      tr: "Soya",
      index: 13,
      allergens: ["AY"]
    },
    {
      value: "molluscs",
      de: "Weichtiere",
      en: "Molluscs",
      tr: "Yumuşakçalar",
      index: 8,
      allergens: ["UM", "LSN", "OYS", "SQU"]
    },
    {
      value: "X99",
      de: "Keine deklarationspflichtigen Allergene enthalten",
      en: "Does not contain declaration obligatory allergens",
      tr: "Beyan edilmesi zorunlu alerjenleri içermez",
      index: 16,
      allergens: ["X99"]
    },
    {
      value: "other",
      de: "Andere",
      en: "Other",
      tr: "Diğer",
      index: 15,
      allergens: [
        "AA",
        "ABD",
        "ABE",
        "ABF",
        "ABG",
        "ABI",
        "ABK",
        "ABN",
        "ACP",
        "AD",
        "ADB",
        "ADF",
        "ADG",
        "ADH",
        "ADI",
        "ADJ",
        "ADK",
        "ADL",
        "ADM",
        "ADP",
        "ADQ",
        "ADR",
        "ADS",
        "ADT",
        "ADV",
        "ADW",
        "AH",
        "AI",
        "AJF",
        "AL",
        "ANO",
        "APL",
        "ASD",
        "AW",
        "BA",
        "BAS",
        "BB",
        "BE",
        "BF",
        "BFH",
        "BFD",
        "BI",
        "BN",
        "BND",
        "BO",
        "BP",
        "BQ",
        "BR",
        "BRC",
        "BRM",
        "BS",
        "CA",
        "CFD",
        "CFH",
        "CHB",
        "CHR",
        "CKF",
        "CL",
        "CLM",
        "CM",
        "CN",
        "CO",
        "COK",
        "CON",
        "CS",
        "CSC",
        "CT",
        "DA",
        "DMF",
        "DP",
        "DYF",
        "EEL",
        "EG",
        "EOD",
        "EP",
        "EV",
        "FA",
        "FH",
        "FT",
        "GE",
        "GK",
        "GL",
        "GOM",
        "GS",
        "GTD",
        "HB",
        "HC",
        "HD",
        "HE",
        "HH",
        "HN",
        "HP",
        "HX",
        "HY",
        "JCH",
        "JFD",
        "KWD",
        "LGD",
        "LMT",
        "LX",
        "MAC",
        "MAL",
        "MFD",
        "MH",
        "ML",
        "MM",
        "MMD",
        "MOD",
        "MSS",
        "NC",
        "NE",
        "NK",
        "NM",
        "NW",
        "OCT",
        "OFD",
        "OGD",
        "ON",
        "ORR",
        "PER",
        "PFD",
        "PGT",
        "PHD",
        "PLC",
        "PM",
        "PN",
        "PO",
        "POM",
        "PP",
        "PRG",
        "PS",
        "QUA",
        "SAD",
        "SAR",
        "SB",
        "SCA",
        "SDF",
        "SF",
        "SFD",
        "SFT",
        "SHD",
        "SHK",
        "SM",
        "SMF",
        "SMR",
        "SMT",
        "SP",
        "SPF",
        "SQ",
        "SR",
        "SS",
        "STG",
        "SU",
        "SX",
        "TA",
        "TD",
        "TFD",
        "TR",
        "TUR",
        "WFD",
        "WHK",
        "WHT",
        "YMD"
      ]
    }
  ]
};

export default allergen_groups;
